import { createReducer, on } from '@ngrx/store';

import { CompanyLanguage, CustomLanguage } from '@ninety/mobile/platform/api';

import { LanguageActions } from './language.actions';

export interface LanguageStateModel {
  companyLanguage: CompanyLanguage | null;
  resetLanguage: CustomLanguage | null;
  /** @deprecated */
  defaultBOSLanguage: CustomLanguage | null;
  isLoaded: boolean;
}

export const initialLanguageState: LanguageStateModel = {
  companyLanguage: null,
  resetLanguage: null,
  defaultBOSLanguage: null,
  isLoaded: false,
};

export const languageReducer = createReducer<LanguageStateModel>(
  initialLanguageState,
  on(LanguageActions.init, (state, companyAndDefault): LanguageStateModel => ({
    ...state,
    ...structuredClone(companyAndDefault),
  })),
  on(LanguageActions.getCompanyLanguageSuccess, (state, { companyLanguage }): LanguageStateModel => ({
    ...state,
    companyLanguage,
    isLoaded: true,
  })),
  on(LanguageActions.getCompanyLanguageError, (state): LanguageStateModel => ({
    ...state,
    isLoaded: true,
  }))
);
